export enum APP_NAME {
  ASSET_MANAGEMENT = "asset-management",
  FLEET_CONFIGURATION_DASHBOARD = "fleet-configuration-dashboard",
}

export enum PARENT_WINDOW_MESSAGE_TYPE {
  T3_IFRAME_TRIGGERED_ROUTE = "t3iFrameTriggeredRoute",
  T3_IFRAME_TRIGGERED_INTERCOM_MESSAGE = "t3iFrameTriggeredIntercomMessage",
  T3_IFRAME_TRIGGERED_ASSET_QUERY_INVALIDATION = "t3iFrameTriggeredAssetQueryInvalidation",
}

export const useParentWindowCommunication = ({
  parentOrigin,
  sourceApp,
  type,
}: {
  parentOrigin: string;
  sourceApp: APP_NAME;
  type: PARENT_WINDOW_MESSAGE_TYPE;
}) => {
  return {
    notifyParentWindow: () =>
      window.parent.postMessage(
        {
          type: type,
          source: sourceApp,
        },
        parentOrigin,
      ),
    sendMessageToParentWindow: (messageToParent: string) =>
      window.parent.postMessage(
        {
          type: type,
          source: sourceApp,
          message: messageToParent,
        },
        parentOrigin,
      ),
  };
};
